import React, { useState, useEffect, useRef, Fragment } from 'react';
import Message from '../components/Message.jsx';
import Typing from '../components/TypingIndicator.jsx';
import Header from '../components/Header.jsx';
import Input from '../components/Input.jsx';
import axios from 'axios';
import Report from '../Report.jsx';
import Menu from '../components/Menu.jsx';
import MessageMenu from '../components/MessageMenu.jsx';
import Sources from '../components/Sources.jsx';
import toast, { Toaster } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { analytic } from '../utils/Analytics.js';
import PromptsSuggestion from '../components/PromptsSuggestion.jsx';
import ConfirmationDialog from '../components/ConfirmationDialog.jsx';
import Loader from '../components/Loader.jsx';
import useWebSocket from 'react-use-websocket';
import LanguageSelection from '../components/LanguageSelection.jsx';
import { useReactMediaRecorder } from 'react-media-recorder';
import { VOICE_CONNECTED, VOICE_CONNECTING, VOICE_DISCONNECTED, VOICE_HANGED_UP, VOICE_LISTENING, VOICE_PAUSED, VOICE_SPEAKING, VOICE_THINKING } from '../utils/voiceStatus.js';
import VoiceMode from '../components/VoiceMode.jsx';
import { Helmet } from 'react-helmet';

const ChatWindow = ({ botResponse, iframeDomain, botApiId, primaryColor, view, showDisclaimer, showVoiceMode, publicMode }) => {
  const { t, i18n } = useTranslation();

  let site = window.location.origin;
  let assetUrl = process.env.REACT_APP_ASSETS_URL;
  const apiURL = process.env.REACT_APP_API_URL;
  const apiKey = process.env.REACT_APP_BOT_API_KEY;
  const websocketURL = process.env.REACT_APP_WEBSOCKET_URL || "bot.brainstormer.dev";
  const SAMPLE_RATE = process.env.REACT_APP_SAMPLE_RATE || 44100;
  const THRESHOLD = process.env.REACT_APP_THRESHOLD || 3;

  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [domain, setDomain] = useState(iframeDomain);
  const [botId, setBotId] = useState(botApiId);
  const [bot, setBot] = useState({
    id: '',
    name: '',
    description: "",
    slug: '',
    image: `${site}/background.png`
  });
  const [primary, setPrimary] = useState(primaryColor);
  const [disabled, setDisabled] = useState(true);
  const [noWelcomeMessage, setNoWelcomeMessage] = useState(false);
  const [showReport, setShowReport] = useState(false);
  const [showHeaderMenu, setShowHeaderMenu] = useState(false);
  const [showMessageMenu, setShowMessageMenu] = useState(false);
  const [selectedMessage, setSelectedMessage] = useState(null);
  const languages = [
    { id: 'english', name: 'English', value: 'en' },
    { id: 'arabic', name: 'عربي', value: 'ar' },
    { id: 'french', name: 'Française', value: 'fr' },
    { id: 'hindi', name: 'हिंदी', value: 'hi' },
    { id: 'spanish', name: 'Español', value: 'es' },
    { id: 'russian', name: 'русский', value: 'ru' },
    { id: 'german', name: 'Deutsch', value: 'de' },
    { id: 'swahili', name: 'Kiswahili', value: 'sw' }
  ];
  const [botLanguages, setBotLanguages] = useState([]);

  const [showSources, setShowSources] = useState(false);
  const [showPrompts, setShowPrompts] = useState(false);
  const [starterPoints, setStarterPoints] = useState();
  const [showLanguageDialog, setShowLanguageDialog] = useState(false);
  const [showClearConvoDialog, setShowClearConvoDialog] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(null);
  const [loader, setLoader] = useState(false);
  const [messageStreaming, setMessageStreaming] = useState(false);

  const [voiceModeEnabled, setVoiceModeEnabled] = useState(false);
  const [voiceMode, setVoiceMode] = useState(false);
  // const [voiceStatus, setVoiceStatus] = useState(VOICE_CONNECTING);
  const [isMicMuted, setIsMicMuted] = useState(true);
  const [isSpeakerMuted, setIsSpeakerMuted] = useState(true);
  const [isAudioInteractionsDisabled, setIsAudioInteractionsDisabled] = useState(true);
  const [audioLevel, setAudioLevel] = useState(0);
  const [audioQueue, setAudioQueue] = useState([]);
  const [voiceErr, setVoiceErr] = useState(false);
  const [hangedUp, setHangedUp] = useState(false);

  const voiceStatus = useRef(VOICE_CONNECTING);
  const audioStatusRef = useRef(null); //recording, paused, stopped
  const mediaRecorderRef = useRef(null);

  const streamRef = useRef(null);
  const playAudioRef = useRef(false);
  const audioContextRef = useRef(null);
  const gainNodeRef = useRef(null);
  const animationFrameRef = useRef(null);
  const isMicMutedRef = useRef(true);
  const isWelcomeMessageRequested = useRef(false);
  const currentAudioSourceRef = useRef(null);
  const audioThresholdRef = useRef(null);

  const textAreaRef = useRef();
  const messageListRef = useRef();
  const didMount = useRef(false);
  let langToast;

  let chatID = localStorage.getItem(`chatId_${botId}`);
  let initialLanguageSet = localStorage.getItem(`initialLanguageSet_${botId}`);

  const socketUrl = chatID ? `wss://${websocketURL}/socket/widget_handler/v2/${chatID}?token=${apiKey}` : null;

  const handleBotResponse = (response) => {
    let language = localStorage.getItem('language') || 'en';

    const isInitialLanguageSet = localStorage.getItem(`initialLanguageSet_${botId}`);

    let bot = response?.data?.data[0]?.attributes;
    let botImage = bot?.ProfileImage?.data?.attributes?.url;

    if (response?.data?.chat_id) {
      localStorage.setItem(`chatId_${botId}`, response?.data?.chat_id);
    }

    setVoiceModeEnabled(bot?.VoiceEnabled);

    if (language === 'en') {
  
      setBot({
        id: response?.data?.data[0]?.id || '',
        name: bot?.Name ? bot?.Name : "Brainstormer",
        description: bot?.Description ? bot?.Description : "",
        image: botImage ? `${assetUrl}${botImage}` : `${site}/App-icon.png`,
        slug: bot?.Slug ? bot?.Slug : ''
      })

    } else {

      let localizedData = bot?.localizations?.data?.find((lng) => lng?.attributes?.locale === language);

      setBot({
        id: response?.data?.data[0]?.id,
        name: localizedData?.attributes?.Name ? localizedData?.attributes?.Name : bot?.Name,
        description: localizedData?.attributes?.Description ? localizedData?.attributes?.Description : bot?.Description,
        image: botImage ? `${assetUrl}${botImage}` : `${site}/App-icon.png`,
        slug: localizedData?.attributes?.Slug ? localizedData?.attributes?.Slug : bot?.Slug
      })
    }

    if(isInitialLanguageSet){
      if (language === 'en') {
  
        if (response?.data?.chat) {
          setMessages([...response?.data?.chat?.chat_history]);
        } else {
          bot?.WelcomeMessage ? setMessages([{ role: 'assistant', content: bot?.WelcomeMessage, is_flagged: 0, reason: '' }]) : setNoWelcomeMessage(true)
        }
  
        setStarterPoints(bot?.StarterPrompts);
  
      } else {
  
        let localizedData = bot?.localizations?.data?.find((lng) => lng?.attributes?.locale === language);
  
        if (response?.data?.chat) {
          setMessages([...response?.data?.chat?.chat_history]);
        } else {
          setMessages([{ role: 'assistant', content: localizedData?.attributes?.WelcomeMessage ?? bot?.WelcomeMessage ?? 'Welcome my master. Your message is my command!', is_flagged: 0, reason: '' }])
        }
  
        setStarterPoints(localizedData?.attributes?.StarterPrompts || bot?.StarterPrompts);
      }
    }

    setDisabled(false);

    let botLanguages = [];

    botLanguages.push(bot?.locale);

    bot?.localizations?.data?.map((lng) => {
      botLanguages.push(lng?.attributes?.locale);
    })

    if (botLanguages.length == 1 && !isInitialLanguageSet) {
      handleLanguageSelection(languages.filter((lng) => lng?.value == bot?.locale)[0]);
    }

    setBotLanguages(botLanguages);
  }

  /**
   * Fetches the chatbot's information and welcome message from the server.
   * If the chatbot has a welcome message, it is added to the messages array.
   * If the chatbot has starter prompts, they are stored in the starterPoints state.
   * The bot's languages are also stored in the botLanguages state.
   * If the language is not English, the localized data is fetched and stored in the bot state.
   * If the language is English, the English data is used.
   * @function
   */
  const fetchInfo = () => {
    let chat_id = localStorage.getItem(`chatId_${botId}`);
    let language = localStorage.getItem('language') || 'en';

    let requestData = {
      domain: domain,
      language: language || 'en'
    }

    if (chat_id) {
      requestData.chat_id = chat_id
    }

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    
    const customVars = {};
    for (const [key, value] of urlParams.entries()) {
      if (key.startsWith('cv_')) {
        const decodedKey = decodeURIComponent(key.substring(3));
        const decodedValue = decodeURIComponent(value);
        customVars[decodedKey] = decodedValue;
      }
    }

    if(customVars){
      requestData['custom_variables'] = customVars;
    }

    setLoader(true);

    axios({
      url: `${apiURL}/bot_by_id/bot_${botId}`,
      method: 'POST',
      data: requestData,
      headers: {
        'Api-token': apiKey
      }
    })
      .then((response) => {
        // console.log(response);
        if (response.status === 200 && response.data.data.length > 0) {
          handleBotResponse(response);

          // if(response.data.chat){
          //   setMessages([...response.data.chat.chat_history]);
          // } else {
          //   if(messages.length === 0){
          //     console.log("messages inside fetch lese syatta", messages, messages.length);
          //     bot.WelcomeMessage ? setMessages((prevMessage) => [...prevMessage, { role: 'assistant', content: bot.WelcomeMessage, is_flagged: 0, reason: '' }]) : setNoWelcomeMessage(true)
          //   }
          // }

          // toast.dismiss(langToast);
          // if (didMount.current && messages.length === 0) {
          //   toast.success(t('Language changed'), {
          //     id: 'language',
          //     position: 'top-right',
          //     style: {
          //       backgroundColor: 'white',
          //       color: primary,
          //       fontSize: '13px',
          //       padding: '5px 7px',
          //       fontWeight: '500'
          //     }
          //   })

          // } else {
          //   didMount.current = true;
          // }
        }
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('Something broke! Please try later.'), {
          position: 'top-right',
          style: {
            backgroundColor: 'white',
            color: 'red',
            fontSize: '13px',
            padding: '5px 7px',
            fontWeight: '500'
          }
        })
      })
      .finally(() => {
        setLoader(false);
      })
  };

  const { sendJsonMessage, readyState } = useWebSocket(socketUrl, {
    onOpen: (event) => handleSocketConnection(event),
    onMessage: (event) => handleSocketOnMessage(event),
    onError: (event) => handleSocketOnError(event),
    shouldReconnect: (closeEvent) => true,
    reconnectInterval: 100,
    retryOnError: true,
    heartbeat: {
      interval: 55000
    }
  });

  const handleSocketConnection = (event) => {
    // console.log("new connection created", event)
  };

/**
 * Handles incoming WebSocket messages and updates the application state accordingly.
 *
 * @param {Object} event - The WebSocket message event containing data.
 *
 * Processes different types of events received from the server:
 * - Ignores 'pong' messages.
 * - Parses JSON data and handles errors if the status is "error".
 * - Updates starter points if questions are present in the response.
 * - Manages voice status transitions for audio-related events such as 'open_audio_success',
 *   'emit_stt', 'play_audio', 'asr_error', 'open_audio_error', 'emit_audio_error', and
 *   'close_audio_success'.
 * - Adjusts text area height and refocuses based on speech-to-text events.
 * - Decodes and plays audio data if the event is 'play_audio'.
 * - Shows error messages using toast notifications when errors occur.
 * - Updates message history with new assistant messages or appends to the last message
 *   if applicable.
 * - Updates typing and message streaming states based on the response.
 */

  const handleSocketOnMessage = (event) => {

    if (event.data == 'pong') return;

    const response = JSON.parse(event.data);

    if (response.status === "error"){
      setIsTyping(false);
      setMessageStreaming(false);

      if(voiceMode){
        exitVoiceMode(false);
      }

      toast.error(t('Something broke! Please try again later'), {
        position: 'top-right',
        style: {
          backgroundColor: 'white',
          color: 'red',
          fontSize: '13px',
          padding: '5px 7px',
          fontWeight: '500'
        }
      });

      return;
    };

    if (response.questions) {
      setStarterPoints(response.questions);
      return;
    }

    if(response.event == 'open_audio_success'){
      startRecording();

      if(response.event == 'open_audio_success' && messages.length == 1 && messages[0].role == 'assistant'){
        playWelcomeMessage();
      }

      setIsMicMuted(false);
      isMicMutedRef.current = false;
      setIsSpeakerMuted(false);
      setIsAudioInteractionsDisabled(false);

      analytic("voice_mode_initiated", null);
    
    } else if(response.event == 'play_welcome_message_error'){
      let data = {
        'event': 'audio_unmute'
      };

      sendJsonMessage(data);

      voiceStatus.current = VOICE_LISTENING;

      let data2 = {
        'event': 'user_interruption',
        'data': {
          'value': 'false'
        }
      }

      sendJsonMessage(data2);

      // audioAnalyser();

    } else if (response.event == "emit_stt") {

      if (response.type == 'complete') {
        voiceStatus.current = VOICE_THINKING;

        audioStatusRef.current = 'stopped';

        let data = {
          'event': 'audio_mute'
        };

        sendJsonMessage(data);

        // pauseRecording();

        setMessages((prevMessage) => [...prevMessage, { role: 'user', content: response.text, is_flagged: 0, reason: '' }]);
      }

    } else if (response.event == "play_audio") {

      if(voiceStatus.current == VOICE_THINKING){
        setAudioQueue([]);
      }

      voiceStatus.current = VOICE_SPEAKING;

      if(!isWelcomeMessageRequested.current){
        let data = {
          'event': 'audio_unmute'
        };
  
        sendJsonMessage(data);
      }

      let data2 = {
        'event': 'user_interruption',
        'data': {
          'value': 'true'
        }
      }

      sendJsonMessage(data2);

      const base64 = response.audio_data;
      const binaryString = atob(base64);
      const bytes = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      if(!audioContextRef.current){
        audioContextRef.current = new AudioContext({
          sampleRate: SAMPLE_RATE
        });
      }

      decodeAndPlay(bytes.buffer);

    } else if(response.event == "asr_error" || response.event == 'open_audio_error' || response.event == 'emit_audio_error' || response.event == 'play_welcome_message_error') {
      
      toast.error(response.message);

      exitVoiceMode(false);
    
    } else if(response.event == 'close_audio_success') {
      
      // setVoiceStatus(VOICE_DISCONNECTED);
    
    } else if(response.event == 'clear_audio') {

      // if (currentAudioSourceRef.current) {
      //   try {
      //     currentAudioSourceRef.current.stop();
      //   } catch (err) {
      //     console.warn('Error stopping source:', err);
      //   }
      //   currentAudioSourceRef.current.disconnect();
      //   currentAudioSourceRef.current = null;
      // }
      
      // setAudioQueue([]);
      // playAudioRef.current = false;
      
      // if (gainNodeRef.current) {
      //   gainNodeRef.current = null;
      // }
      
      // voiceStatus.current = VOICE_LISTENING;

      // let data = {
      //   'event': 'user_interruption',
      //   'data': {
      //     'value': 'false'
      //   }
      // }

      // sendJsonMessage(data);
      
    } else {

      const newMessage = {
        role: 'assistant',
        content: response.message,
        is_flagged: 0,
        reason: ''
      };
  
      setMessages((prevMessages) => {
        if (prevMessages.length > 0 && prevMessages[prevMessages.length - 1].role === 'assistant') {
          return [...prevMessages.slice(0, -1), { ...prevMessages[prevMessages.length - 1], content: prevMessages[prevMessages.length - 1].content + response.message }];
        } else {
          return [...prevMessages, newMessage];
        }
      });
  
      if (response?.data?.finish_reason === "stop") {
        setMessageStreaming(false);
      }
  
      setIsTyping(false);
    }

  };

  const handleSocketOnError = (event) => {
    console.log("Error =====>", event);

    if(voiceMode){
      exitVoiceMode();
    }
  };
  
  /**
   * Handle message send event. If the user is currently typing or the message is
   * being streamed, do nothing. Otherwise, set the user as typing, set the message
   * as streaming, add the message to the conversation log, and send the message
   * to the server. Analytics are also sent.
   *
   * @param {string} text The text of the message to send
   */
  const handleMessageSend = (text) => {
    if (isTyping || messageStreaming) return;

    setIsTyping(true);
    setMessageStreaming(true);

    setMessages((prevMessage) => [...prevMessage, { role: 'user', content: text, is_flagged: 0, reason: '' }]);
    sendMessage(text);

    let data = {
      bot_name: bot.name
    }

    analytic("send_message", data);
  };

  const sendMessage = (text) => {

    const language = languages.find((lng) => lng.value === i18n.language);

    // const chat_id = localStorage.getItem('chatId');

    let requestData = {
      "event": "text_message",
      "data": {
        "query": text ? text : 'hi, who are you and how can you help me?',
        "bot_id": `bot_${botId}`,
        "language": language?.name
      }
    }

    sendJsonMessage(requestData);

    // if (chat_id) {
    //   requestData.chat_id = chat_id
    // }

    // axios({
    //   url: `${apiURL}/widget_handler`,
    //   method: 'POST',
    //   data: requestData,
    //   headers: {
    //     'Api-token': apiKey
    //   }
    // })
    //   .then((response) => {
    //     if (response.data.status === 'success') {
    //       setMessages((prevMessage) => [...prevMessage, { role: 'assistant', content: response.data.message, is_flagged: 0, reason: '' }]);
    //       setIsTyping(false);
    //       setNoWelcomeMessage(false);
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     setIsTyping(false);
    //     setNoWelcomeMessage(false);
    //     toast.error('Something broke! Please try later.', {
    //       position: 'top-right',
    //       style: {
    //         backgroundColor: 'white',
    //         color: primary,
    //         fontSize: '13px',
    //         padding: '5px 7px',
    //         fontWeight: '500'
    //       }
    //     })
    //   })
  };

  const scrollToEnd = () => {
    const messageList = messageListRef.current;
    messageList.scrollTop = messageList.scrollHeight;
  };

  const openVoiceMode = () => {
    setAudioLevel(0);
    setVoiceMode(true);

    connectVoiceMode();
  }

  const exitVoiceMode = () => {
    setVoiceMode(false);
    setHangedUp(false);

    disconnectVoiceMode();

    analytic("voice_mode_exit", null);
  }

  const connectVoiceMode = () => {
    voiceStatus.current = VOICE_CONNECTING;

    const language = languages.find((lng) => lng.value === i18n.language);

    let socketData = {
      'event': 'open_audio',
      'data': {
        'bot_id': botId,
        'language': language
      }
    }

    startCallibration();

    sendJsonMessage(socketData);
  }

  const disconnectVoiceMode = (status, sendMessage = true) => {
    setIsSpeakerMuted(true);
    setIsMicMuted(true);
    isMicMutedRef.current = true;
    setIsAudioInteractionsDisabled(true);

    setVoiceErr(false);

    voiceStatus.current = status || VOICE_CONNECTING;

    if(sendMessage){
      let socketData = {
        'event': 'close_audio'
      }
  
      sendJsonMessage(socketData);
    }
    
    stopRecording();

    handleCloseAudio();
  }

  const startCallibration = async () => {
    let stream = streamRef.current;
  
    if (!stream) {
      stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          channelCount: 1,
          sampleRate: SAMPLE_RATE,
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        }
      });
      streamRef.current = stream;
    }
  
    let audioContext = audioContextRef.current;
  
    if (!audioContext) {
      audioContext = new AudioContext({
        sampleRate: SAMPLE_RATE
      });
      audioContextRef.current = audioContext;
    }
  
    try {
      await audioContext.audioWorklet.addModule('/audio/audio-callibration.worklet.js');
    } catch (error) {
      console.error('Error loading audio worklet:', error);
      return;
    }
  
    const source = audioContext.createMediaStreamSource(stream);
    const workletNode = new AudioWorkletNode(audioContext, 'audio-callibration');
  
    const samples = [];
  
    workletNode.port.onmessage = (event) => {
      if (event.data.event === 'audio_threshold') {
        const rms = event.data.data;

        samples.push(rms);
  
        if (samples.length >= 200) {
          const mean = samples.reduce((sum, val) => sum + val, 0) / samples.length;

          let audioThreshold = Math.max(0.05, Math.min(mean * 2.5, 0.35));
    
          audioThresholdRef.current = audioThreshold;
  
          workletNode.disconnect();
          source.disconnect();
        }
      }
    };
  
    source.connect(workletNode);
    workletNode.connect(audioContext.destination);
  };
  

  const startRecording = async() => {
    try {
      let stream = streamRef.current;
    
      if(!stream){
        stream = await navigator.mediaDevices.getUserMedia({ 
          audio: {
            channelCount: 1,
            sampleRate: SAMPLE_RATE,
            echoCancellation: true,
            noiseSuppression: true,
            autoGainControl: true,
          }
        });

        streamRef.current = stream;
      }

      if(!mediaRecorderRef.current){
        mediaRecorderRef.current = new MediaRecorder(stream);
      }

      // mediaRecorderRef.current = new MediaRecorder(stream);
      // audioChunksRef.current = [];

      // mediaRecorderRef.current.ondataavailable = (event) => {
      //     audioChunksRef.current.push(event.data);
      // };

      // mediaRecorderRef.current.onstop = () => {
      //     const blob = new Blob(audioChunksRef.current, { type: 'audio/webm' });
      //     setAudioBlob(blob);
      //     const url = URL.createObjectURL(blob);
      //     setAudioURL(url);
      //     // Stop the stream tracks to release microphone
      //     stream.getTracks().forEach(track => track.stop());
      // };

      // setVoiceStatus(VOICE_LISTENING);
      if(messages.length == 1 && messages[0].role == 'assistant'){
        voiceStatus.current = VOICE_SPEAKING;
      } else {
        voiceStatus.current = VOICE_LISTENING;

        let data = {
          'event': 'user_interruption',
          'data': {
            'value': 'false'
          }
        }
  
        sendJsonMessage(data);
      }

      audioStatusRef.current = 'recording';
      mediaRecorderRef.current.start();

      audioAnalyser();
      // setIsRecording(true);
      // setAudioBlob(null); // Clear previous recording on new start
      // setAudioURL(null); // Clear previous URL on new start
  } catch (error) {
      console.error('Error accessing microphone:', error);
      // alert('Could not access microphone. Please ensure it is connected and permissions are granted.');
      setVoiceErr(true);
      setIsAudioInteractionsDisabled(true);
    }
  }

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      mediaRecorderRef.current = null;

      audioStatusRef.current = 'stopped';
    }
  }

  const pauseRecording = () => {
    if((voiceStatus.current == VOICE_LISTENING || voiceStatus.current == VOICE_THINKING || voiceStatus.current == VOICE_SPEAKING) && streamRef.current){
      const audioTrack = streamRef.current?.getAudioTracks()[0];

      if (audioTrack) {
        audioTrack.enabled = false;
      }
    }
  }

  const resumeRecording = () => {
    if((voiceStatus.current == VOICE_PAUSED || voiceStatus.current == VOICE_SPEAKING) && streamRef.current){
      const audioTrack = streamRef.current?.getAudioTracks()[0];

      if (audioTrack) {
        audioTrack.enabled = true;
        
        if (!mediaRecorderRef.current && audioStatusRef.current === 'stopped') {
          mediaRecorderRef.current = new MediaRecorder(streamRef.current);
          mediaRecorderRef.current.start();
          audioStatusRef.current = 'recording';
        }
        
        // audioAnalyser();
      }
    }
  }

  const handleInterruption = () => {
    // if(isWelcomeMessageRequested.current) return;

    if (currentAudioSourceRef.current) {
      try {
        currentAudioSourceRef.current.stop();
      } catch (err) {
        console.warn('Error stopping source:', err);
      }
      currentAudioSourceRef.current.disconnect();
      currentAudioSourceRef.current = null;
    }

    if(gainNodeRef.current){
      gainNodeRef.current = null;
    }
    
    setAudioQueue([]);
    playAudioRef.current = false;
    
    voiceStatus.current = VOICE_LISTENING;

    let data = {
      'event': 'user_interruption',
      'data': {
        'value': 'false'
      }
    }

    sendJsonMessage(data);
  }

  const playWelcomeMessage = () => {
    let d1 = {
      event: 'audio_mute'
    }

    sendJsonMessage(d1);

    let d2 = {
      'event': 'play_welcome_message'
    }

    sendJsonMessage(d2);
    
    isWelcomeMessageRequested.current = true;

    // voiceStatus.current = VOICE_SPEAKING;
  }

  const handleMicMuteToggle = () => {
    if(voiceStatus.current == VOICE_LISTENING || voiceStatus.current == VOICE_THINKING || voiceStatus.current == VOICE_SPEAKING){
      let data = {
        'event': 'audio_mute'
      };

      sendJsonMessage(data);

      setIsMicMuted(true);
      isMicMutedRef.current = true;
      // pauseRecording();

      if (gainNodeRef.current) {
        gainNodeRef.current.gain.value = 0;
      }

      if(voiceStatus.current == VOICE_SPEAKING) {
        if (audioContextRef.current) {
          // audioContextRef.current.suspend();
        }
      }

      voiceStatus.current = VOICE_PAUSED;
    } else if(voiceStatus.current == VOICE_PAUSED){

      setIsMicMuted(false);
      isMicMutedRef.current = false;
      // resumeRecording();

      if (gainNodeRef.current) {
        gainNodeRef.current.gain.value = 1;
      }

      if (audioContextRef.current) {
        // audioContextRef.current.resume();

        if (audioQueue.length === 0 && !playAudioRef.current) {
          voiceStatus.current = VOICE_LISTENING;

          let data = {
            'event': 'audio_unmute'
          };
    
          sendJsonMessage(data);

          let data2 = {
            'event': 'user_interruption',
            'data': {
              'value': 'false'
            }
          }
    
          sendJsonMessage(data2);
        } else {
          voiceStatus.current = VOICE_SPEAKING;

          let data = {
            'event': 'user_interruption',
            'data': {
              'value': 'true'
            }
          }
    
          sendJsonMessage(data);
        }
      }
    }
  };

  const hangupVoice = () => {
    disconnectVoiceMode(VOICE_HANGED_UP);

    setHangedUp(true);
  }

  const reOpenVoice = () => {
    setHangedUp(false);

    voiceStatus.current = VOICE_CONNECTING;
    
    connectVoiceMode();

    analytic("voice_mode_reconnect", null);
  }

  /**
   * Close the audio context and reset related variables.
   *
   * If stopRecordingFlag is true, stop recording first.
   * Then close the audio context, reset the analyser, animation frame,
   * data array, play audio flag, gain node, and audio queue.
   *
   * @param {boolean} [stopRecordingFlag=false] - Whether to stop recording
   *                                            before closing the audio context.
   * @returns {void}
   */
  const handleCloseAudio = (stopRecordingFlag = false) => {

    if(audioStatusRef.current){
      audioStatusRef.current = null;
    }

    if(streamRef.current){
      streamRef.current.getTracks().forEach(track => track.stop());
      streamRef.current = null;
    }

    if(audioContextRef.current) {
      audioContextRef.current.close();
      audioContextRef.current = null;
    }

    if(animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    if(playAudioRef.current) {
      playAudioRef.current = false;
    }

    if(gainNodeRef.current) {
      gainNodeRef.current = null;
    }

    if (currentAudioSourceRef.current) {
      currentAudioSourceRef.current.disconnect();
      currentAudioSourceRef.current = null;
    }

    if(audioThresholdRef.current){
      audioThresholdRef.current = null;
    }

    setAudioLevel(0);
    setAudioQueue([]);
  }


  /**
   * Decodes an arrayBuffer and plays the audio.
   * @param {ArrayBuffer} arrayBuffer The arrayBuffer to decode and play.
   */
  const decodeAndPlay = (arrayBuffer) => {
    let audioContext = audioContextRef.current;

    if(audioContext){
      audioContext.decodeAudioData(arrayBuffer).then((buffer) => {
        const monoBuffer = buffer.numberOfChannels > 1 ? stereoToMono(audioContext, buffer) : buffer;

        if (playAudioRef.current) {
          setAudioQueue((prevQueue) => [...prevQueue, monoBuffer]);
        } else {
          playAudio(monoBuffer);
        }
      })
    }
  };

  /**
   * Plays an audio buffer. If the audio is already playing, adds the buffer
   * to the end of the queue.
   * @param {AudioBuffer} buffer The audio buffer to play.
   */
  const playAudio = (buffer) => {
    if(hangedUp){
      return;
    }

    const audioContext = audioContextRef.current;
    if(!audioContext) return;

    if (currentAudioSourceRef.current) {
      try {
        currentAudioSourceRef.current.stop();
      } catch (err) {
        console.warn('Error stopping previous source:', err);
      }
      currentAudioSourceRef.current.disconnect();
      currentAudioSourceRef.current = null;
    }

    const source = audioContext.createBufferSource();
    source.buffer = buffer;
    currentAudioSourceRef.current = source;

    if (!gainNodeRef.current) {
      gainNodeRef.current = audioContext.createGain();
      gainNodeRef.current.connect(audioContext.destination);
    }

    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;

    const dataArray = new Uint8Array(analyser.frequencyBinCount);

    source.connect(gainNodeRef.current);
    gainNodeRef.current.connect(analyser);
    analyser.connect(audioContext.destination);

    // gainNodeRef.current.gain.value = 1;
    
    playAudioRef.current = true;

    const updateAudioLevel = () => {
      analyser.getByteFrequencyData(dataArray);

      let sum = 0;
      for (let i = 0; i < dataArray.length; i++) {
        sum += dataArray[i];
      }

      const average = sum / dataArray.length;
      setAudioLevel(average);

      animationFrameRef.current = requestAnimationFrame(updateAudioLevel);
    };
  
    if(analyser && voiceStatus.current == VOICE_LISTENING){
      updateAudioLevel();
    }

    source.onended = () => {
      playAudioRef.current = false;
      currentAudioSourceRef.current = null;

      if (audioQueue.length > 0) {
        playAudio(audioQueue.shift());
      } else {
        if(isWelcomeMessageRequested.current){
          isWelcomeMessageRequested.current = false;
        }

        if (voiceMode && !isMicMutedRef.current) {

          voiceStatus.current = VOICE_LISTENING;

          let data = {
            'event': 'audio_unmute'
          };

          sendJsonMessage(data);

          let data2 = {
            'event': 'user_interruption',
            'data': {
              'value': 'false'
            }
          }
    
          sendJsonMessage(data2);

          if (streamRef.current) {

            const audioTrack = streamRef.current.getAudioTracks()[0];
            if (audioTrack) {
              audioTrack.enabled = true;
            }
            
            // resumeRecording();
            audioStatusRef.current = 'recording';
            
            // audioAnalyser();
          }
        }
      }
    };

    source.start(0);
  };

  /**
   * Start the audio analyser to send audio data to the server.
   *
   * This function is called when the user clicks the microphone button.
   * It requests access to the user's microphone and creates an audio context.
   * Then it loads and registers the audio worklet, which is responsible for
   * processing the audio data and sending it to the server.
   *
   * @returns {void}
   */
  const audioAnalyser = async () => {

    let stream = streamRef.current;
    
    if(!stream){
      stream = await navigator.mediaDevices.getUserMedia({ 
        audio: {
          channelCount: 1,
          sampleRate: SAMPLE_RATE,
          echoCancellation: true,
          noiseSuppression: true,
          autoGainControl: true,
        }
      });
      streamRef.current = stream;
    }

    let audioContext = audioContextRef.current;

    if(!audioContext){
      audioContext = new AudioContext({
        sampleRate: SAMPLE_RATE
      });

      audioContextRef.current = audioContext;
    }

    // Load and register the audio worklet
    try {
      await audioContext.audioWorklet.addModule('/audio/audio-processor.worklet.js');
    } catch (error) {
      console.error('Error loading audio worklet:', error);
      return;
    }

    const analyser = audioContext.createAnalyser();
    analyser.fftSize = 2048;

    const source = audioContext.createMediaStreamSource(stream);
    const workletNode = new AudioWorkletNode(audioContext, 'audio-processor');

    function bufferToBase64(buffer) {
      const bytes = new Uint8Array(buffer);
      let binary = '';
      
      for (let i = 0; i < bytes.byteLength; i++) {
        binary += String.fromCharCode(bytes[i]);
      }

      return btoa(binary); // Encode to base64
    }

    let smoothedAudioLevel = 0;
    const SMOOTHING_FACTOR = 0.9;

    // Handle messages from the audio worklet
    workletNode.port.onmessage = (event) => {
      if (event.data.event === 'emit_audio') {
        const language = languages.find((lng) => lng.value === i18n.language);

        const base64Audio = bufferToBase64(event.data.data);

        let audioData = {
          'event': event.data.event,
          'data': {
            'bot_id': botId,
            'language': language,
            'audio_data': base64Audio
          }
        }

        const currentLevel = event.data.audioLevel;

        smoothedAudioLevel = smoothedAudioLevel * SMOOTHING_FACTOR + currentLevel * (1 - SMOOTHING_FACTOR);
        
        if(smoothedAudioLevel > audioThresholdRef.current && voiceStatus.current == VOICE_SPEAKING){
          console.log("HIGHER AUDIO LEVELESLSLSLSL", smoothedAudioLevel, audioThresholdRef.current);
          handleInterruption();
        }
        // Only send audio data when listening to reduce processing load
        // if(voiceStatus.current == VOICE_LISTENING){
          sendJsonMessage(audioData);
        // }
      }
    };

    source.connect(analyser);
    source.connect(workletNode);

    workletNode.connect(audioContext.destination);

    const bufferLength = analyser.frequencyBinCount;

    const dataArray = new Uint8Array(bufferLength);

    const updateAudioLevel = () => {
      if(!analyser) return;

      if(voiceStatus.current == VOICE_LISTENING){
        analyser.getByteFrequencyData(dataArray);
  
        let sum = 0;
        for (let i = 0; i < bufferLength; i++) {
          sum += dataArray[i];
        }
  
        const average = sum / bufferLength;
        setAudioLevel(average);
      } else {
        setAudioLevel(0);
      }

      animationFrameRef.current = requestAnimationFrame(updateAudioLevel);
    };

    // if(analyser && voiceStatus.current == VOICE_LISTENING){
      updateAudioLevel();
    // }
  };

  const stereoToMono = (audioContext, stereoBuffer) => {
    const length = stereoBuffer.length;
    const sampleRate = stereoBuffer.sampleRate;
  
    const left = stereoBuffer.getChannelData(0);
    const right = stereoBuffer.numberOfChannels > 1
      ? stereoBuffer.getChannelData(1)
      : left;
  
    const monoData = new Float32Array(length);
  
    for (let i = 0; i < length; i++) {
      monoData[i] = (left[i] + right[i]) / 2;
    }
  
    const monoBuffer = audioContext.createBuffer(1, length, sampleRate);
    monoBuffer.copyToChannel(monoData, 0);
  
    return monoBuffer;
  }

  const handleShowMenu = () => {
    setShowHeaderMenu(!showHeaderMenu);
  };

  const handleMessageMenu = (e, message) => {
    setShowMessageMenu(!showMessageMenu);
    if (message) {
      setSelectedMessage(message);
    }
  };

  const handleSourceMenu = () => {
    setShowSources(!showSources);
  };

  const handlePromptsMenu = () => {
    setShowPrompts(!showPrompts);
    setShowHeaderMenu(false);
    setTimeout(() => {
      scrollToEnd();
    }, [200]);
  };

  const handlePromptClick = (text) => {
    handlePromptsMenu()
    handleMessageSend(text);
  };

  const handleLanguageClick = (language) => {
    setSelectedLanguage(language);
    setShowLanguageDialog(true);
    handleShowMenu();
  };

  const handleLanguageChange = () => {
    analytic("change_language", { language: selectedLanguage.value });

    localStorage.removeItem(`chatId_${botId}`);
    i18n.changeLanguage(selectedLanguage.value);
    localStorage.setItem('language', selectedLanguage.value);
    setMessages([]);
    setShowLanguageDialog(false);

    if(showVoiceMode && voiceMode && voiceModeEnabled){
      exitVoiceMode();
    }
  };

  const handleLanguageCancel = () => {
    setSelectedLanguage(null);
    setShowLanguageDialog(false);
  };

  const handleRefreshClick = () => {
    setShowClearConvoDialog(!showClearConvoDialog);
    setShowHeaderMenu(false);
  };

  /**
   * Handles confirmation of conversation clearing.
   * Removes chat ID and initial language set from local storage,
   * resets messages state, and hides the refresh confirmation dialog.
   */
  const handleRefreshConfirm = () => {
    localStorage.removeItem(`chatId_${botId}`);
    localStorage.removeItem(`initialLanguageSet_${botId}`);
    setMessages([]);
    handleRefreshClick();

    if(showVoiceMode && voiceMode && voiceModeEnabled){
      exitVoiceMode();
    }
  };

  /**
   * Handles cancellation of conversation clearing.
   * Hides the refresh confirmation dialog.
   */
  const handleRefreshCancel = () => {
    handleRefreshClick();
  };
  
  /**
   * Toggles the width of the chat window by sending a message to the parent window.
   * After toggling, it scrolls to the end of the chat content.
   */
  const handleToggleWidth = () => {
    window.parent.postMessage({
      func: 'toggleWidth',
    }, `https://${domain}`);

    setTimeout(() => {
      scrollToEnd();
    }, 300)
  };

  const handleLanguageSelection = (language) => {
    i18n.changeLanguage(language?.value);
    localStorage.removeItem(`chatId_${botId}`);
    localStorage.setItem('language', language?.value);
    localStorage.setItem(`initialLanguageSet_${botId}`, true);
    fetchInfo();
  };

  useEffect(() => {
    scrollToEnd();
  }, [messages]);

  useEffect(() => {
    if (messages.length == 0) {
      handleBotResponse(botResponse);
    }

    if (messages.length == 1) {
      setShowPrompts(true);
      setTimeout(() => {
        scrollToEnd();
      }, [200]);
    }

  }, [messages]);

  useEffect(() => {
    if (primary) {
      document.documentElement.style.setProperty('--primary-color', primary);
    }
  }, [primary]);

  useEffect(() => {
    let data = {
      parent_domain: domain
    }

    analytic("app_invokation", data);

    const targetOrigin = domain.includes('localhost') ? `http://${domain}` : `https://${domain}`;

    if(window.self !== window.top){
      window.parent.postMessage({
        page: 'ready',
      }, targetOrigin);
    }
  }, []);

  useEffect(() => {
    if (noWelcomeMessage) {
      setMessages([{ role: 'assistant', content: 'Welcome my master. Your message is my command!', is_flagged: 0, reason: '' }]);
      setNoWelcomeMessage(false);
    }
  }, [noWelcomeMessage]);

  return (
    <Fragment>
      <Helmet>
        <title>{bot?.name}</title>
        <meta name="title" content={bot?.name} />
        <meta name="description" content={bot?.description} />
      </Helmet>
      <div className="flex-1 justify-between flex flex-col h-[100dvh] relative">
        <Header 
          bot={bot} 
          handleRefresh={handleRefreshClick} 
          primary={primary} 
          handleToggleWidth={handleToggleWidth} 
          view={view} 
          isIntialLanguageSelected={initialLanguageSet}
          showVoiceMode={showVoiceMode && voiceModeEnabled}
          handleOpenVoiceMode={openVoiceMode}
          publicMode={publicMode}
        />
        <Menu 
          bot={bot} 
          domain={domain} 
          showHeaderMenu={showHeaderMenu} 
          setShowHeaderMenu={setShowHeaderMenu}
          messages={messages} 
          handleShowMenu={handleShowMenu} 
          primary={primary} 
          languages={languages} 
          botLanguages={botLanguages} 
          fetchInfo={fetchInfo} 
          handleLanguageClick={handleLanguageClick} 
          handlePromptsMenu={handlePromptsMenu} 
          handleRefresh={handleRefreshClick} 
          prompts={starterPoints} 
          botId={botId}
          voiceMode={showVoiceMode && voiceModeEnabled}
          publicMode={window.self == window.top}
          chatId={chatID}
        />
        <div id="message-list" ref={messageListRef} className="flex flex-col h-full py-1 pb-0 sm:py-6 overflow-y-auto justify-between">
          {
            (!initialLanguageSet && botLanguages.length > 0) ? (
              <LanguageSelection 
                primary={primary} 
                botLanguages={botLanguages} 
                languages={languages} 
                handleLanguageSelection={handleLanguageSelection} 
              />
            ) : (
              <>
                <div id="messages-list-inside" className='w-auto h-auto px-[10px] pb-2'>
                  {messages.map((message, index) => (
                    <Message
                      key={index}
                      message={message}
                      image={bot.image}
                      primary={primary}
                      setShowReport={setShowReport}
                      handleMessageMenu={handleMessageMenu}
                      messageStreaming={messageStreaming}
                    />
                  ))}
                  {isTyping && <Typing image={bot.image} primary={primary} />}
                </div>
                <PromptsSuggestion 
                  data={starterPoints} 
                  showPrompts={showPrompts} 
                  setShowPrompts={setShowPrompts} 
                  handlePromptClick={handlePromptClick} 
                  primary={primary} 
                />
              </>
            )
          }
        </div>
        <Input
          botName={bot.name}
          textAreaRef={textAreaRef}
          handleMessageSend={handleMessageSend}
          isTyping={isTyping}
          setIsTyping={setIsTyping}
          messageStreaming={messageStreaming}
          setMessageStreaming={setMessageStreaming}
          disabled={disabled}
          primary={primary}
          handleShowMenu={handleShowMenu}
          showDisclaimer={showDisclaimer}
          isIntialLanguageSelected={initialLanguageSet}
        />
        <Report showReport={showReport} botId={botId} setShowReport={setShowReport} primary={primary} fadeEffect={'zoomIn'} selectedMessage={selectedMessage} messages={messages} />
        <MessageMenu 
          bot={bot} 
          domain={domain} 
          showMessageMenu={showMessageMenu} 
          handleMessageMenu={handleMessageMenu} 
          primary={primary} 
          setShowReport={setShowReport} 
          showSources={showSources} 
          setShowSources={setShowSources} 
          handleSourceMenu={handleSourceMenu} 
          selectedMessage={selectedMessage} 
          botId={botId}
          voiceMode={showVoiceMode && voiceModeEnabled}
          publicMode={window.self == window.top}
          chatId={chatID}
        />
        <Sources 
          showSources={showSources} 
          setShowSources={setShowSources} 
          handleSourceMenu={handleSourceMenu} 
        />
        <ConfirmationDialog
          title={t(`Are you sure you want to change the language to `) + t(`${selectedLanguage?.id}`) + "?" + t(` Doing so will clear this conversation.`)}
          showDialog={showLanguageDialog}
          handleConfirm={handleLanguageChange}
          handleCancel={handleLanguageCancel}
          primary={primary}
        />
        <ConfirmationDialog
          title={t('Are you sure you want to clear conversation?')}
          showDialog={showClearConvoDialog}
          handleConfirm={handleRefreshConfirm}
          handleCancel={handleRefreshCancel}
          primary={primary}
        />
        <Loader primary={primary} showLoader={loader} />
        <VoiceMode 
          botImage={bot.image}
          botName={bot.name}
          primary={primary}
          voiceModeStatus={voiceMode}
          voiceStatus={voiceStatus.current}
          audioLevel={audioLevel}
          isSpeakerMuted={isSpeakerMuted}
          isMicMuted={isMicMuted}
          isAudioInteractionsDisabled={isAudioInteractionsDisabled}
          hangedUp={hangedUp}
          voiceErr={voiceErr}
          handleMicMuteToggle={handleMicMuteToggle}
          handleHangupVoice={hangupVoice}
          handleReOpenVoice={reOpenVoice}
          handleCloseVoiceMode={exitVoiceMode}
        />
        <Toaster />
      </div>
    </Fragment>
  );
}

export default ChatWindow;
